// extracted by mini-css-extract-plugin
export var toggleButton = "juWAQ";
export var toggleButtonIcon = "C9v_0";